import React from 'react';
import { useSelector } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { isConsumerArea } from '../../CommonSelectors/CommonAreaSelector';
import { ClientFooter } from '../../ConsumerArea/components/Footer/FooterView';
import { theme } from '../BeFi20.meta';
import { Survey } from './Survey';

export default () => {
  const isClientArea = useSelector(isConsumerArea);

  return (
    <ThemeProvider theme={theme}>
      <Survey />

      {isClientArea && <ClientFooter />}
    </ThemeProvider>
  );
};
